<template lang="html">
    <div>
        <app-layout :loading="loading">
            <div slot="title" v-if="currentUser.id == user.id">
                Bilgilerim
            </div>
            <div slot="title" v-if="currentUser.id != user.id && user.id > 0">
                Kullanıcı Güncelle
            </div>
            <div slot="title" v-if="currentUser.id != user.id && user.id == 0">
                Kullanıcı Ekle
            </div>
            <div slot="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box">
                            <div class="box-body">
                                <div v-for="item in formMessages">
                                    <div class="alert" :class="'alert-' + item.type">
                                        {{ item.message }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>E-Posta Adresi</label>
                                    <input type="text" class="form-control" v-model="user.email" />
                                </div>
                                <div class="form-group">
                                    <label>Ad</label>
                                    <input type="text" class="form-control" v-model="user.name" />
                                </div>
                                <div class="form-group">
                                    <label>Soyad</label>
                                    <input type="text" class="form-control" v-model="user.surname" />
                                </div>
                                <div class="form-group" v-if="hasPermission('users.save')">
                                    <label>İzinler</label>
                                    <select2 :data="permissions"
                                             :selected="user.permissions"
                                             v-on:onChange="onUserPermissionChanged" />
                                </div>
                                <div class="form-group" v-if="hasPermission('users.save')">
                                    <label>Panolar</label>
                                    <select2 :data="dashboards"
                                             :selected="user.dashboards"
                                             v-on:onChange="onUserDashboardChanged" />
                                </div>
                                <div class="form-group" v-if="hasPermission('users.save')">
                                    <label>Servisler</label>
                                    <select2 :data="services"
                                             :selected="user.services"
                                             v-on:onChange="onUserServiceChanged" />
                                </div>
                                <div class="form-group">
                                    <label>Öntanımlı Pano</label>
                                    <select2 :data="dashboards"
                                             :selected="user.defaultDashboard"
                                             :maxSelection="1"
                                             v-on:onChange="onUserDefaultDashboardChanged" />
                                </div>
                                <div class="form-group" v-if="hasPermission('users.save')">
                                    <label>Durumu</label>
                                    <div class="checkbox">
                                        <label><input type="checkbox" v-model="user.status" /> Aktif</label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Şifre</label>
                                    <input type="password" class="form-control" v-model="user.password" />
                                </div>
                                <div class="form-group">
                                    <label>Şifre Tekrarı</label>
                                    <input type="password" class="form-control" v-model="user.passwordRepeat" />
                                </div>
                                <div class="form-actions">
                                    <button type="button" v-on:click="submit" :disabled="saving" class="btn btn-success">
                                        <span v-if="saving == false">Kaydet</span>
                                        <span v-if="saving">Lütfen bekleyiniz...</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import $ from 'jquery';
import parallel from 'async/parallel';
import _map from 'lodash.map';
import _values from 'lodash.values';
import AppLayout from '../components/app_layout.vue';
import Select2 from '../components/select.v2.vue';

export default {
    components: {
        'app-layout': AppLayout,
        'select2': Select2
    },
    data: function () {
        return {
            user: {
                id: 0,
                email: '',
                name: '',
                surname: '',
                password: '',
                passwordRepeat: '',
                services: [],
                dashboards: [],
                permissions: [],
                status: false,
                defaultDashboard: []
            },
            services: [],
            dashboards: [],
            permissions: [],
            loading: true,
            saving: false,
            formMessages: [],
            currentUser: {}
        }
    },
    mounted: function () {
        var $this = this;
        this.currentUser = $this.$app.getUser();
        if (this.$app.hasPermission('users.save')) {
            parallel([
                function (next) {
                    $this.$app.get('/api/v1/permissions/all', function(xhr) {
                        var response = xhr.responseJSON;
                        $this.permissions = $.map(response.permissions, function (permission) {
                            return {
                                id: permission.id,
                                text: permission.name
                            }
                        });
                        next();
                    });
                },
                function (next) {
                    $this.$app.get('/api/v1/dashboards/all', function(xhr) {
                        var response = xhr.responseJSON;
                        $this.dashboards = $.map(response.dashboards, function (dashboard) {
                            return {
                                id: dashboard.id,
                                text: dashboard.title
                            }
                        });
                        next();
                    });
                },
                function (next) {
                    $this.$app.get('/api/v1/services/all', function(xhr) {
                        var response = xhr.responseJSON;
                        $this.services = $.map(response.services, function (service) {
                            return {
                                id: service.id,
                                text: service.name
                            }
                        });
                        next();
                    });
                },
                function (next) {
                    var id = $this.$router.currentRoute.query.id;
                    if (id > 0) {
                        $this.$app.get('/api/v1/users/' + id, function(xhr) {
                            var response = xhr.responseJSON;
                            $this.user.id = response.user.id;
                            $this.user.email = response.user.email;
                            $this.user.name = response.user.name;
                            $this.user.surname = response.user.surname;
                            $this.user.services = _map(response.user.services, 'id');
                            $this.user.dashboards = _map(response.user.dashboards, 'id');
                            $this.user.permissions = _values(response.user.permissions);
                            if (response.user.defaultDashboard > 0) {
                                $this.user.defaultDashboard = [response.user.defaultDashboard];
                            }
                            $this.user.status = response.user.status;
                            next();
                        });
                    } else {
                        next();
                    }
                }
            ], function (err, results) {
                $this.loading = false;
            });
        } else {
            var id = $this.$router.currentRoute.query.id;
            if (id > 0) {
                parallel([
                    function (next) {
                        $this.$app.get('/api/v1/users/' + id + '/dashboards', function(xhr) {
                            var response = xhr.responseJSON;
                            $this.dashboards = $.map(response.dashboards, function (dashboard) {
                                return {
                                    id: dashboard.id,
                                    text: dashboard.title
                                }
                            });
                            next();
                        });
                    },
                    function (next) {
                        $this.$app.get('/api/v1/users/' + id, function(xhr) {
                            var response = xhr.responseJSON;
                            $this.loading = false;
                            $this.user.id = response.user.id;
                            $this.user.email = response.user.email;
                            $this.user.name = response.user.name;
                            $this.user.surname = response.user.surname;
                            $this.user.services = _map(response.user.services, 'id');
                            $this.user.dashboards = _map(response.user.dashboards, 'id');
                            $this.user.permissions = _values(response.user.permissions);
                            if (response.user.defaultDashboard > 0) {
                                $this.user.defaultDashboard = [response.user.defaultDashboard];
                            }
                            $this.user.status = response.user.status;
                            next();
                        });
                    }
                ], function (err, results) {
                    $this.loading = false;
                });
            }
        }
    },
    methods: {
        hasPermission: function (permission) {
            return this.$app.hasPermission(permission);
        },
        submit: function (e) {
            var $this = this;
            this.saving = true;
            var params = {
                id: this.user.id,
                email: this.user.email,
                name: this.user.name,
                surname: this.user.surname,
                password: this.user.password,
                services: this.user.services,
                dashboards: this.user.dashboards,
                permissions: this.user.permissions,
                status: this.user.status ? 1 : 0,
                default_dashboard: this.user.defaultDashboard
            };
            this.$app.post('/api/v1/users', params, function (xhr) {
                var data = xhr.responseJSON;
                if (data.formMessages !== undefined) {
                    $this.formMessages = data.formMessages
                }
                if (data.meta.httpStatusCode === 200) {
                    // Öntanımlı pano ayarı saklanmalı.
                    if ($this.currentUser.id === $this.user.id && $this.user.defaultDashboard.length > 0) {
                        var user = $this.$app.getUser();
                        user.defaultDashboard = $this.user.defaultDashboard[0];
                        $this.$app.updateUser(user);
                    }
                } else if (data.meta.httpStatusCode === 201) {
                    $this.user = {
                        id: 0,
                        email: '',
                        name: '',
                        surname: '',
                        password: '',
                        passwordRepeat: '',
                        services: [],
                        dashboards: [],
                        permissions: [],
                        defaultDashboard: [],
                        status: false
                    };
                }
                $this.saving = false;
                window.scrollTo(0, 0);
            });
        },
        onUserServiceChanged: function (data) {
            this.user.services = data;
        },
        onUserDashboardChanged: function (data) {
            this.user.dashboards = data;
        },
        onUserPermissionChanged: function (data) {
            this.user.permissions = data;
        },
        onUserDefaultDashboardChanged: function (data) {
            this.user.defaultDashboard = data;
        }
    },
    watch: {
        '$route': function () {
            if (this.$router.currentRoute.query.id == undefined) {
                this.user = {
                    id: 0,
                    email: '',
                    name: '',
                    surname: '',
                    password: '',
                    passwordRepeat: '',
                    services: [],
                    dashboards: [],
                    permissions: [],
                    status: false,
                    defaultDashboard: []
                };
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// user_save.vue?2d24a611